"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Default = void 0;
var default_1 = require("./default");
Object.defineProperty(exports, "Default", { enumerable: true, get: function () { return default_1.Default; } });
//# sourceMappingURL=index.js.map